import { put } from 'redux-saga/effects'
import { fetchCategoriesByCompanyAction } from '../../actions'
import { fetchCategoriesByCompanyId, FetchCategoriesByCompanyResponse } from '../_http/company'

export function* fetchCategoriesByCompanySaga(action: ReturnType<typeof fetchCategoriesByCompanyAction.request>) {
  const { companyId } = action.payload
  try {
    const response: FetchCategoriesByCompanyResponse = yield fetchCategoriesByCompanyId({ companyId })
    yield put(fetchCategoriesByCompanyAction.success({ categories: response.categories }))
  } catch (error) {
    yield put(fetchCategoriesByCompanyAction.failure())
  }
}
